import { CommonRequestOptions, makeRequest } from '../makeRequest';
import { WikiNamespaces, WikiObject } from './types';

type GetWikiRequestOptions = CommonRequestOptions & {
   namespace: WikiNamespaces;
   identifier: string | number;
   unpatrolled: boolean;
};

export async function getWiki({
   namespace,
   identifier,
   unpatrolled,
   ...common
}: GetWikiRequestOptions): Promise<WikiObject> {
   return await makeRequest('get', `/wikis/${namespace}/${identifier}`, {
      ...common,
      query: {
         unpatrolled,
      },
   });
}
